import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsMetaTraderContent } from '../utils/platformsContent';

export const usePlatformsMetaTraderContent = () =>
  usePlatformsSectionContent(parsePlatformsMetaTraderContent);
